import { BaseModel } from '@tcc-mono/shared/data-access';

export class Animal extends BaseModel {
  color_code?: string;
  color_correct?: boolean;
  color_id?: number;
  color_name?: string;
  country_code?: string;
  created_at?: string;
  date_of_birth?: string;
  date_of_birth_mutation?: string;
  gender_code?: string;
  gender_correct?: boolean;
  gender_id?: number;
  gender_name?: string;
  id: number;
  identification_number?: string;
  is_healthy?: boolean;
  is_project?: boolean;
  not_healthy_reason_code?: string;
  not_healthy_reason_id?: number;
  not_healthy_reason_name?: string;
  price?: number;
  price_ex_vat?: number;
  remarks?: string;
  rvo_arrival_at?: string;
  rvo_departure_at?: string;
  work_number?: string;
  weight?: number;
  warranty?: boolean;
  warranty_checked?: boolean;
  warranty_till?: string;
  ride_relation?: string;
  ride_loading_ubn?: string;

  rvo_passport_at?: string;
  rvo_export_at?: string;

  gt_36?: boolean;

  selection_mark_color?: string | null;
  selection_mark_color_name?: string | null;
}
